<template>
  <div class="main">
    <div class="header">
      <div class="item">
        <div>当前店铺：</div>
        <div style="color: #D9001B;">{{ data.mallId }}</div>
      </div>
      <div class="item">
        <div>店铺名称：</div>
        <div style="color: #D9001B;">{{ data.mallName }}</div>
      </div>
      <div class="item">
        <div>店铺代码：</div>
        <div style="color: #D9001B;">
          <span @mouseover="onSelectText">{{ data.secretKey }}</span>
        </div>
        <!-- <div v-if="data.secretKey" style="margin-left: 10px;">
          <el-button type="primary" @click="onCopy">复制</el-button>
        </div> -->
      </div>
      <div class="item">
        <div>用户名：</div>
        <div style="color: #D9001B;">{{ data.userName }}</div>
        <div style="margin-left: 10px;">
          <el-button type="primary" @click="onChangeName">更换用户名</el-button>
          <el-button type="primary" @click="onChangePwd">修改密码</el-button>
        </div>
      </div>
      <div style="color: #9d9d9d;font-size: 12px;">用户名仅为系统登录使用。</div>
    </div>
    <div class="content">
      <div style="margin-bottom: 15px;">
        <el-button type="primary" @click="onBind" :disabled="data.mainType == 2">绑定新店铺</el-button>
      </div>
      <el-table row-key="mallId" :data="data.mallInfos" border style="width: 100%" v-loading="tbLoading">
        <el-table-column prop="mallId" label="店铺编号" min-width="180" />
        <el-table-column prop="mallName" label="店铺名称" min-width="200" />
        <el-table-column prop="mainType" label="是否主店铺" width="85">
          <template slot-scope="{row}">
            <el-tag v-if="row.mainType == 1">主店铺</el-tag>
            <el-tag type="info" v-else>子店铺</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="secretKey" label="店铺代码" min-width="300" />
        <el-table-column align="center" label="排序" width="120">
          <template slot-scope="{row, $index}">
            <el-button icon="el-icon-top" @click="setUp($index)" v-if="$index != 0"></el-button>
            <el-button icon="el-icon-bottom" @click="setDown($index)"
              v-if="$index != (data.mallInfos.length - 1)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="195px" fixed="right">
          <div slot-scope="{row}" style="text-align: right;" v-if="row.mallId != data.mallId">
            <el-button type="primary" @click="setCurrent(row)">切换店铺</el-button>
            <el-button type="danger" @click="onDelete(row)">取消关联</el-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <change-name ref="changeName" @close-saved="getData" />
    <change-pwd ref="changePwd" @close-saved="getData" />
    <bind ref="bind" @close-saved="getData" />
  </div>
</template>
<script>
import changeName from "./changeName";
import changePwd from "./changePwd";
import bind from "./bind";

export default {
  components: {
    changeName,
    changePwd,
    bind,
  },
  data() {
    return {
      api: require('@/api/pdd/mall').default,
      data: {
        logo: "",
        mallId: null,
        mallName: "",
        sysType: "",
        userName: "",
        secretKey: "",
        mainType: 0,
        mallInfos: [],
      },
      tbLoading: false
    }
  },
  methods: {
    getData() {
      this.api.getLoginUser().then(res => {
        this.data = {
          ...res,
          sysType: this.$platformJs.getName(res.platform)
        }

        var mall_list = [];
        if (res.mallInfos) {
          res.mallInfos.forEach(x => {
            mall_list.push({ logo: x.logoUrl, mallId: x.mallId, mallName: x.mallName, mainType: res.mainType, secretKey: x.secretKey, expirationDate: this.$commonJs.toDateString(x.expirationDate) })
          })
        } else {
          mall_list.push({ logo: res.logoUrl, mallId: res.mallId, mallName: res.mallName, mainType: res.mainType, secretKey: res.secretKey, expirationDate: this.$commonJs.toDateString(res.expirationDate) })
        }

        localStorage.setItem("mall_list", JSON.stringify(mall_list));
        this.$store.dispatch("setMallList");
      })
    },
    onSelectText(event) {
      console.log("event", event);
      // 获取一个Selection对象
      const selection = window.getSelection();
      // 先清空一下以选择的内容
      selection?.removeAllRanges();
      // 创建一个range对象
      const range = document.createRange();
      // 让range对象包含一个node的内容
      range.selectNodeContents(event.target);
      // 向selection中添加一个区域（range）
      selection?.addRange(range);
    },
    onCopy() {
      navigator.clipboard.writeText(this.data.secretKey).then(() => {
        this.$message.success('复制成功');
      }).catch(err => {
        console.log('复制失败', err);
        this.$message.error('复制失败');
      });
    },
    onChangeName() {
      this.$refs.changeName.openEdit({
        mallId: this.data.mallId,
        userName: this.data.userName,
      })
    },
    onChangePwd() {
      this.$refs.changePwd.openEdit({
        mallId: this.data.mallId,
        userName: this.data.userName,
      })
    },
    onBind() {
      this.$refs.bind.open()
    },
    setUp(index) {
      var mall1 = this.data.mallInfos[index];
      var mall2 = this.data.mallInfos[index - 1];

      var data = {
        mallId1: mall1.mallId,
        mallSort1: mall1.sort - 1,
        mallId2: mall2.mallId,
        mallSort2: mall2.sort + 1,
      }
      console.log("setUp", index, data);


      this.tbLoading = true;
      this.api.saveSort(data).then(res => {
        console.log("res", res)
        this.tbLoading = false;
        if (!res) {
          this.data.mallInfos[index].sort = data.mallSort1;
          this.data.mallInfos[index - 1].sort = data.mallSort2;
          this.data.mallInfos = this.data.mallInfos.sort((a, b) => a.sort - b.sort);
        } else {
          this.$message.error("保存失败");
        }
      })
    },
    setDown(index) {
      var mall1 = this.data.mallInfos[index];
      var mall2 = this.data.mallInfos[index + 1];

      var data = {
        mallId1: mall1.mallId,
        mallSort1: mall1.sort + 1,
        mallId2: mall2.mallId,
        mallSort2: mall2.sort - 1,
      }

      this.tbLoading = true;
      this.api.saveSort(data).then(res => {
        console.log("res", res)
        this.tbLoading = false;
        if (!res) {
          this.data.mallInfos[index].sort = data.mallSort1;
          this.data.mallInfos[index + 1].sort = data.mallSort2;
          this.data.mallInfos = this.data.mallInfos.sort((a, b) => a.sort - b.sort);
        } else {
          this.$message.error("保存失败");
        }
      })
    },
    setCurrent(data) {
      var day = this.$commonJs.getIntervalDays(data.expirationDate, new Date())
      if (day < 0) {
        this.$confirm(data.mallName + ' 店铺已过期', '续费提醒', {
          confirmButtonText: '去续费',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          window.open("https://fuwu.pinduoduo.com/service-market/service-detail?detailId=86398")
        }).catch(() => { });
        return;
      }

      this.api.changemall(data.secretKey).then(res => {
        if (res.errorCode) {
          this.$message.error(res.errorMessage);
        } else {
          localStorage.setItem("sys_type", "pdd");
          localStorage.setItem("token", res.accessToken);
          localStorage.setItem("user-info", JSON.stringify({
            logo: res.logoUrl,
            userName: res.userName,
            mallId: res.mallId,
            mallName: res.mallName,
            mainType: res.mainType,
            secretKey: res.secretKey,
            expirationDate: this.$commonJs.toDateString(res.expirationDate)
          }));
          var mall_list = [];
          if (res.mallInfos) {
            res.mallInfos.forEach(x => {
              mall_list.push({ logo: x.logoUrl, mallId: x.mallId, mallName: x.mallName, mainType: res.mainType, secretKey: x.secretKey, expirationDate: this.$commonJs.toDateString(x.expirationDate) })
            })
          } else {
            mall_list.push({ logo: res.logoUrl, mallId: res.mallId, mallName: res.mallName, mainType: res.mainType, secretKey: res.secretKey, expirationDate: this.$commonJs.toDateString(res.expirationDate) })
          }
          localStorage.setItem("mall_list", JSON.stringify(mall_list));
          window.location.reload();
        }
      })
    },
    onDelete(data) {
      this.$confirm("确认取消关联吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.deleteMall({ linkId: data.id }).then(res => {
          // var mall_list = this.$store.state.user.mallList;
          // mall_list = Array(...mall_list).filter(x => x.mallId != data.mallId);
          // localStorage.setItem("mall_list", JSON.stringify(mall_list));
          // this.$store.dispatch("setMallList");
          this.$message.success("取消关联成功");
          this.getData();
        }).catch((error) => {
          this.$message.error("取消关联失败");
        })
      }).catch(() => { });
    }
  }
}
</script>
<style lang="scss">
.main {

  .header {
    border: 1px solid #E4E7ED;
    padding: 10px;

    .item {
      height: 40px;
      display: flex;
      align-items: center;
    }
  }

  .content {
    margin-top: 20px;
    //min-height: 400px;
    border: 1px solid #E4E7ED;
    padding: 10px;
  }
}
</style>